import type {AppSpecWithUserConnector} from '@cohort/shared/schema/apps/app';
import {CustomAuthComponent} from '@cohort/wallet/apps/CustomAuthComponent';
import {OAuthComponent} from '@cohort/wallet/apps/OAuthComponent';

export type AuthComponentProps = {
  appSpec: AppSpecWithUserConnector;
};

export const AuthComponent: React.FC<AuthComponentProps> = ({appSpec}) => {
  switch (appSpec.userConnector.type) {
    case 'oauth1':
    case 'oauth2':
      return <OAuthComponent appSpec={appSpec} />;
    case 'custom':
      return <CustomAuthComponent appSpec={appSpec} />;
  }
};
